export default __webpack_public_path__ + "static/media/011-goggles.34e5c656.svg";